// A person's product-tour progress, saved on their account (KPR-612).
// keepr-api docs/SCHEMA.md § "Product-tour progress". Self only.
import { api } from '../api/client';

import { API_TOUR_PROGRESS_URL, API_TOUR_PROGRESS_ONE_URL } from '../utils';

export const TOUR_STATUSES = ['in-progress', 'completed', 'dismissed'];

// The one read, made at sign-in so the Home offer never flickers. It never
// throws: `ok: false` means "we do not know", and a caller must treat that as
// "do not offer" (see `canOfferTour`), not as "not started".
export async function loadTourProgress() {
	try {
		const { data } = await api.get(API_TOUR_PROGRESS_URL);
		return { ok: true, tours: (data && data.tours) || {} };
	} catch (e) {
		return { ok: false, tours: {} };
	}
}

// Saves the state of one tour at the version the person saw. The same write
// twice is harmless. Returns the stored record.
export async function saveTourProgress(tourId, status, version) {
	const { data } = await api.put(API_TOUR_PROGRESS_ONE_URL(tourId), { status, version });
	return data;
}

// The effective state of a tour at the version this build ships. No record,
// or a record of an older version, is 'not-started' even if the older one was
// completed. Mirrors the server's `GET /api/tour-progress/{id}?version=`.
export function tourState(progress, tourId, version) {
	const rec = progress && progress.tours && progress.tours[tourId];
	if (!rec || rec.version < version) return 'not-started';
	return rec.status;
}

// Whether to offer a tour on Home: only when the read worked and the person
// has not started it (at this version). A failed read hides the offer.
export function canOfferTour(progress, tourId, version) {
	return !!(progress && progress.ok) && tourState(progress, tourId, version) === 'not-started';
}
